export const STORAGE_KEYS = {
  theme: 'travelGuide.theme',
  savedPlaces: 'travelGuide.savedPlaces',
  placeCatalog: 'travelGuide.placeCatalog',
  itinerary: 'travelGuide.itinerary',
};

export const readStorage = (key, fallback) => {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch (error) {
    return fallback;
  }
};

export const writeStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // No-op: storage can fail in private mode or quota limits.
  }
};
